import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const CURRENT_VERSION = '4.22.10';

const lastKnownVersion = localStorage.getItem('groovefx_version');
if (lastKnownVersion !== CURRENT_VERSION) {
  console.log(`SYSTEM: Protocol updated to ${CURRENT_VERSION}`);
  localStorage.setItem('groovefx_version', CURRENT_VERSION);
}

window.onerror = function(message, source, lineno, colno, error) {
  console.error(`UPLINK FAILURE: ${message}`, error);
  const root = document.getElementById('root');
  if (root) {
    root.innerHTML = `
      <div style="padding:40px; color:#ff4444; font-family:sans-serif; background:#05040f; height:100vh; display:flex; flex-direction:column; justify-content:center; align-items:center; text-align:center;">
        <h1 style="font-size:3rem; font-weight:900; letter-spacing:-0.05em; margin-bottom:10px;">Handshake Interrupted</h1>
        <p style="color:#aaa; max-width:600px; margin-bottom:30px;">Error: ${message}</p>
        <button onclick="location.reload()" style="background:white; color:black; padding:15px 30px; border-radius:12px; border:none; cursor:pointer; font-weight:bold; text-transform:uppercase; letter-spacing:0.2em;">Retry Link</button>
      </div>`;
  }
  return false;
};

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(<React.StrictMode><App /></React.StrictMode>);
}